import { getPasswordStrength } from '@lib/validations'
import { clsx } from 'clsx'

interface PasswordStrengthProps {
  password: string
}

export default function PasswordStrength({ password }: PasswordStrengthProps) {
  if (!password) return null

  const strength = getPasswordStrength(password)

  const bars = [
    { active: true, color: strength === 'weak' ? 'bg-destructive' : strength === 'medium' ? 'bg-yellow-400' : 'bg-green-500' },
    { active: strength !== 'weak', color: strength === 'medium' ? 'bg-yellow-400' : 'bg-green-500' },
    { active: strength === 'strong', color: 'bg-green-500' },
  ]

  const label = {
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
  }[strength]

  const labelColor = {
    weak: 'text-destructive',
    medium: 'text-yellow-500',
    strong: 'text-green-600',
  }[strength]

  return (
    <div className="space-y-1">
      <div className="flex gap-1.5">
        {bars.map((bar, i) => (
          <div
            key={i}
            className={clsx(
              'h-1.5 flex-1 rounded-full transition-all duration-300',
              bar.active ? bar.color : 'bg-border'
            )}
          />
        ))}
      </div>
      <p className={clsx('text-xs font-medium', labelColor)}>Password strength: {label}</p>
    </div>
  )
}
